import axios from 'axios';
import { baseUrl, apiKey } from '../config';

class  MatchService  {
  constructor() {
  }
  getMatchOdds =  async (matchId, params = {}) =>  {
    try {
      const response = await axios.get(`${baseUrl}/matches/${matchId}/odds`, {
        headers: {
          ['x-signature']: apiKey,
        },
        params,
      });

      return {
        success: true,
        data: response?.data?.data || response,
      };
    } catch (error) {
      console.error(error);
      return { error: 'Server error' };
    }
  }
}


const instance = new MatchService();
export { instance as MatchService };